import React, { ReactNode } from 'react';
import { View, StyleSheet, Platform } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import { useTheme } from '../../context/ThemeContext';
import { createThemedStyles } from '../../theme/useThemedStyles';
import { isWeb } from '../../utils/platformUtils';

type Props = {
  children: ReactNode;
};

const WebPinLayout = ({ children }: Props) => {
  const styles = useWebPinLayoutStyles();
  const { colors } = useTheme();

  if (!isWeb) {
    return <>{children}</>;
  }

  return (
    <View style={styles.root}>
      <LinearGradient
        colors={[colors.primary.main, colors.primary.dark]}
        style={StyleSheet.absoluteFill}
        start={{ x: 0, y: 0 }}
        end={{ x: 1, y: 1 }}
      />
      <View style={styles.center}>
        <View style={styles.card}>{children}</View>
      </View>
    </View>
  );
};

const useWebPinLayoutStyles = createThemedStyles((colors) => ({
  root: {
    flex: 1,
    minHeight: '100vh' as unknown as number,
    width: '100%',
  },
  center: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 24,
  },
  card: {
    width: '100%',
    maxWidth: 400,
    backgroundColor: colors.surface,
    borderRadius: 16,
    padding: 32,
    alignItems: 'center',
    ...(Platform.OS === 'web' ? { boxShadow: '0 12px 40px rgba(0,0,0,0.15)' } : {}),
  },
}));

export default WebPinLayout;
